import { format } from 'date-fns'

export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '-'
  const date = new Date(value)
  if (isNaN(date.getTime())) return '-'
  return format(date, 'dd.MM.yyyy HH:mm')
}

export function toInputDateTime(value: string | null | undefined): string {
  if (!value) return ''
  const date = new Date(value)
  if (isNaN(date.getTime())) return ''
  return format(date, "yyyy-MM-dd'T'HH:mm")
}

export function fromInputDateTime(value: string | null | undefined): string | null {
  if (!value) return null
  const date = new Date(value)
  if (isNaN(date.getTime())) return null
  return date.toISOString()
}

function getSessionDeadlineUntil(
  startsAt: string | null | undefined,
  hours: number,
): string | null {
  if (!startsAt) return null
  const start = new Date(startsAt)
  if (isNaN(start.getTime())) return null

  return new Date(start.getTime() - Math.max(0, hours) * 60 * 60 * 1000).toISOString()
}

export function getSessionRegistrationUntil(
  startsAt: string | null | undefined,
  hours: number,
): string | null {
  return getSessionDeadlineUntil(startsAt, hours)
}

export function getSessionCancellationUntil(
  startsAt: string | null | undefined,
  hours: number,
): string | null {
  return getSessionDeadlineUntil(startsAt, hours)
}
